(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data
    const product = JSON.parse(section.querySelector(".productJSON").textContent);

    // note, the starting activeVariant is set in the section liquid file, when options are changed we fetch the new variant data from the server
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);
    let activeVariantMetafields = JSON.parse(section.querySelector(".productVariantMetafieldsJSON").textContent)
    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/
        // setup product swipers
    let productSwiper = null;
    let dialogSwiper = null;
    let variantGallery = true;

    function initSwiper() {
        // set variant gallery
        variantGallery = section.querySelector('.productVisualSwiper').classList.contains('variantGallery');

        productSwiper = new Swiper(section.querySelector(".productVisualSwiper"), {
            slidesPerView: 1,
            spaceBetween: 20,
            autoHeight: true,
            navigation: {
                prevEl: section.querySelector(".productVisualSwiper .swiper-button-prev"),
                nextEl: section.querySelector(".productVisualSwiper .swiper-button-next")
            },
            on: {
                slideChange: function () {
                    if (!section.querySelector(".productVisualSwiperSlide")) {
                        return;
                    }

                    // pause all videos
                    section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                        element.pause();
                    });
                }
            }
        });

        // play video on slide play click
        section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
            element.addEventListener("click", function () {
                // get video
                const video = this.closest(".productVisualSwiperSlide").querySelector("video");

                if (!video) {
                    return;
                }

                // remove play button if it hasn't already been removed
                this.querySelector(".productVisualSwiperSlidePlay")?.remove();

                // show controls
                video.controls = true;

                // play video
                video.play();
            });
        });

        // visual dialog listeners
        const visualDialog = section.querySelector('.productVisualDialog');
        const zoomButton = section.querySelector('.productVisualDialogTopButtonZoom');

        // dialog swiper
        dialogSwiper = new Swiper(section.querySelector(".productVisualDialogSwiper"), {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            zoom: {
                maxRatio: 2,
                toggle: false,
            },
            navigation: {
                prevEl: section.querySelector(".productVisualDialogSwiper .swiper-button-prev"),
                nextEl: section.querySelector(".productVisualDialogSwiper .swiper-button-next")
            },
            on: {
                slideChange: function () {
                    // change slide number
                    section.querySelector('.productVisualDialogTopCount span').textContent = `${parseInt(this.realIndex) + 1}`
                }
            }
        });

        // zoom indicator sets up the zoom settings - background change and add icon
        section.querySelector('.productVisualDialogTopButtonSetup').addEventListener('click', () => {
            visualDialog.classList.toggle('zoom');
        })

        // zoom button zooms in and out
        zoomButton.addEventListener('click', function () {
            this.classList.contains('active') ? dialogSwiper.zoom.out() : dialogSwiper.zoom.in();
            this.classList.toggle('active');
        })

        // open by clicking the normal swiper
        section.querySelector('.productVisualSwiper')?.addEventListener('click', function (e) {
            if (e.target.classList.contains('swiper-button-prev') || e.target.classList.contains('swiper-button-next')) return;
            document.querySelector('body').classList.add('noScroll');
            // slide to proper image
            dialogSwiper.slideTo(parseInt(productSwiper.realIndex));
            // change slide number
            section.querySelector('.productVisualDialogTopCount span').textContent = `${parseInt(productSwiper.realIndex) + 1}`
            // open dialog
            visualDialog.showModal();
        })

        // close function - reset
        visualDialog?.addEventListener('close', () => {
            document.querySelector('body').classList.remove('noScroll');
            // reset zoom
            visualDialog.classList.remove('zoom');
            zoomButton.classList.remove('active');
            dialogSwiper.zoom.out();
        })

        // close on dialog
        visualDialog?.addEventListener('click', function (e) {
            if (e.target === this) this.close();
            if (e.target === section.querySelector(".productVisualDialogSwiper")) this.close();
            if (e.target.classList.contains("swiper-zoom-container")) this.close();
        })

        // close button
        section.querySelector('.productVisualDialogTopButtonClose')?.addEventListener('click', function (e) {
            visualDialog.close();
        })
    }

    // initialize the swiper
    initSwiper();

    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!section.querySelector(`.productSellingOptionInput[value="sub"]:checked`);
    }

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productSellingPlanSelect').value) || null;
    }

    // update display on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", async function () {
            // update the variant
            if (this.classList.contains('productOptionsItemUpdate')) {
                // create array of selected option ids
                const optionIDs = [];
                section.querySelectorAll(".productOptionsItemUpdate").forEach(element => {
                    if (element.checked === true) {
                        optionIDs.push(element.dataset.id);
                    } else if (element.tagName === 'SELECT') {
                        optionIDs.push(element.value);
                    }
                })
                // fetch updated variant data
                const response = await fetch(`/products/${product.handle}?view=active-variant&option_values=${optionIDs.join(',')}`)
                    .then(response => response.json());

                // update active variant
                activeVariant = response.active_variant;
                activeVariantMetafields = response.active_variant_metafields;

                // if set to otp default, change current subscription status
                if (section.querySelector('.productSellingOptionInput')) {
                    this.classList.contains('defaultOTP')
                        ? section.querySelector('.productSellingOptionInput[value="otp"]').checked = true
                        : section.querySelector('.productSellingOptionInput[value="sub"]').checked = true;

                }
            }
            updateProduct().catch(err => console.error(err));
        });
    })

    async function updateProduct() {
        // check if variant wasn't found (null would be returned from the fetch)
        if (!activeVariant) {
            section.querySelector(".productPurchaseAtc").disabled = true;
            section.querySelector(".productPurchaseAtc").textContent = "Not Available";
            return;
        }

        /**************
         Variant Image
         ***************/

        if (variantGallery) {
            try {
                // if page with style choices, use selected path to ensure proper images
                const response = await fetch(`${window.location.pathname}?variant=${activeVariant.id}&sections=main-product`)
                if (response.ok) {
                    const data = await response.json();
                    const content = data["main-product"]
                    // create a new element and parse out contents
                    const contentDiv = document.createElement('div');
                    contentDiv.innerHTML = content;
                    const newSwiper = contentDiv.querySelector('.productVisual').innerHTML;
                    // destroy old swiper and update with new media
                    if (newSwiper) {
                        // destroy both swipers
                        await productSwiper.destroy(true, true);
                        await dialogSwiper.destroy(true, true);
                        document.querySelector('.productVisual').innerHTML = contentDiv.querySelector('.productVisual').innerHTML;
                        // run the event listeners
                        initSwiper();
                    }
                }
            } catch (e) {
                console.warn("Variant image unable to update");
                console.error(e);
            }
        } else {
            // no special selector, try to find variant image
            if (activeVariant.featured_image) {
                // change active slide
                productSwiper.slideTo(activeVariant.featured_image.position - 1);
            }
        }

        /*******
         Title
         ********/

        if (section.querySelector('.productTitleVariant')) {
            section.querySelector('.productTitleVariant').textContent = activeVariant.title;
        }

        if (section.querySelector('.productOptionsItemLabelVariant')) {
            section.querySelector('.productOptionsItemLabelVariant').textContent = activeVariant.title.toUpperCase();
        }

        /**************************
         Description and bottom info
         ***************************/

        const variantIdString = String(activeVariant.id);
        section.querySelectorAll(`[data-variant]`).forEach(el => {
            el.dataset.variant === variantIdString ? el.classList.add('active') : el.classList.remove('active')
        });

        // selector label for color or fragrance
        if (section.querySelector('.productOptionsItemValuesName')) {
            section.querySelectorAll('.productOptionsItemValuesName').forEach(el => el.textContent = activeVariant.title);
        }

        // swap shipping notice if available
        if (section.querySelector('.productPurchaseShippingSub')) {
            section.querySelector('.productPurchaseShippingSub').classList.toggle('active', isSubscription());
        }

        // if there is a shipping delay, show
        section.querySelectorAll('.productDelayItem')?.forEach(el => {
            el.dataset.id === String(activeVariant.id) ? el.classList.add('active') : el.classList.remove('active');
        })

        /**************
         Price
         ***************/

        let allocationPrice = 0;
        if (product.selling_plan_groups.length > 0 && activeVariant.selling_plan_allocations[0]?.price) {
            allocationPrice = activeVariant.selling_plan_allocations[0].price;
        }

        // make sure variant has a sub and subscription has been chosen
        const subscription = isSubscription() && allocationPrice !== 0

        // update price
        section.querySelectorAll('.productPriceActual')?.forEach(el => {
            // check if subscription
            const textContent = subscription ? allocationPrice : activeVariant.price;
            // check if it needs extra zeros
            el.textContent = el.parentElement.classList.contains('productSellingOptionPrice') ? price(textContent, true) : price(textContent);
        })

        // if savings is present, add
        if (section.querySelector('.productPriceSavings')) {
            const savingsActual = subscription ? allocationPrice : activeVariant.price;
            const savingsCompare = subscription ? activeVariant.price : activeVariant.compare_at_price;
            section.querySelector('.productPriceSavings').textContent = savingsCompare > savingsActual ? `${Math.round((100 * (savingsCompare - savingsActual)) / savingsCompare)}% off` : "";
        }

        // update compare at price
        if (subscription) {
            section.querySelector('.productCompare').textContent = activeVariant.price > allocationPrice ? price(activeVariant.price) : "";
        } else {
            section.querySelector('.productCompare').textContent = activeVariant.compare_at_price > activeVariant.price ? price(activeVariant.compare_at_price) : "";
        }

        // update title on subscriptions
        if (section.querySelector('.productSellingOptionExtra')) {
            section.querySelector('.productSellingOptionExtra').innerHTML = activeVariant.price > allocationPrice ? `<span class="patrol-sr-only">Regular price: </span><s>${price(activeVariant.price, true)}</s> <span class="patrol-sr-only">Subscription price: </span>${price(allocationPrice)}` : "";
        }

        // update the subscription savings badge and benefit line
        if (section.querySelector('.productSellingSub')) {
            let savings = 0;
            if (allocationPrice !== 0 && activeVariant.price > allocationPrice) {
                savings = Math.round((100 * (activeVariant.price - allocationPrice)) / activeVariant.price);
            }
            const badge = section.querySelector('.productSellingBadge');
            const benefit = section.querySelector('.productSellingBenefitsSavings');
            badge.textContent = `Save ${savings}%`;
            benefit.textContent = `Save ${savings}% on every order`;
            badge.classList.toggle('hide', savings === 0);
            benefit.classList.toggle('hide', savings === 0);
        }

        // update onetime price (only shows if there's a subscription)
        if (section.querySelector('.productSellingOptionPriceSpan')) {
            section.querySelector('.productSellingOptionPriceSpan').textContent = price(activeVariant.price, true);
        }

        /**********************
         Show/hide selling plans
         ***********************/

        // if variant has no selling plan. select otp and hide plans
        if (section.querySelector('.productSellingOptionInput')) {
            if (activeVariant.selling_plan_allocations.length === 0) {
                section.querySelectorAll('.productSellingOptionInput')?.forEach(el => {
                    el.checked = el.value === "otp"
                })
                // hide the whole subscribe block (pill, option, benefits, plans)
                section.querySelector('.productSellingSub').classList.add('hide');
                section.querySelector('.productSellingPlan').classList.remove('active');
            } else {
                // reveal the subscribe block
                section.querySelector('.productSellingSub').classList.remove('hide');
                // if subscriptions, check if sub is checked and reveal the options
                section.querySelector('.productSellingOptionInput:checked')?.value === "sub"
                    ? section.querySelector('.productSellingPlan').classList.add('active')
                    : section.querySelector('.productSellingPlan').classList.remove('active');
            }
        }


        /**************
         ATC Enable/Disable
         ***************/

            // check if the variant is in stock
            // check metafield items first, is it marked sold out, or is a bundle with an item sold out
        const metaSoldOut = activeVariantMetafields?.marked_sold_out || activeVariantMetafields?.has_bundle_item_sold_out;
        if (activeVariant.available && !metaSoldOut) {
            section.querySelector(".productPurchaseAtc").disabled = false;
            section.querySelector(".productPurchaseAtc").textContent = activeVariantMetafields.is_preorder ? "Pre-order" : "Add To Cart";
            // hide atc and show notify me button
            section.querySelector(".productSoldOut").disabled = true;
            section.querySelector(".productSoldOutWrap").classList.remove('active');
            section.querySelector(".productPurchase").classList.remove('hide');
        } else {
            section.querySelector(".productPurchaseAtc").disabled = true;
            section.querySelector(".productPurchaseAtc").textContent = "Sold Out";
            // show atc and show notify me button
            section.querySelector(".productSoldOut").disabled = false;
            section.querySelector(".productSoldOut").textContent = section.querySelector(".productSoldOut").dataset.text;
            // variants marked to hide notify me get a disabled sold out button instead
            if (activeVariantMetafields.hide_notify_me) {
                section.querySelector(".productSoldOut").disabled = true;
                section.querySelector(".productSoldOut").textContent = "Sold Out";
            }
            section.querySelector(".productSoldOutWrap").classList.add('active');
            section.querySelector(".productPurchase").classList.add('hide');
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    /**************
     Initial Selection
     ***************/

    // ensure active variant is not visually hidden by liquid
    function syncInitialOptions() {
        let corrected = null;

        section.querySelectorAll('.productOptionsItem').forEach(fieldset => {
            // selects always carry a value, only radio groups can end up with nothing checked
            const inputs = fieldset.querySelectorAll('.productOptionsItemValuesLabelInput');
            if (inputs.length === 0 || fieldset.querySelector('.productOptionsItemValuesLabelInput:checked')) {
                return;
            }
            inputs[0].checked = true;
            corrected = inputs[0];
        });

        return corrected;
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    // a corrected selection goes through the change handler instead, so it refetches the variant first
    const correctedInput = syncInitialOptions();
    correctedInput
        ? correctedInput.dispatchEvent(new Event("change"))
        : updateProduct().catch(err => console.error(err));

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelector(".productPurchaseQuantityMinus")?.addEventListener("click", function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector(".productPurchaseQuantityDisplay").textContent = String(quantity);
        updateProduct().catch(err => console.error(err));
    });

    // plus
    section.querySelector(".productPurchaseQuantityAdd")?.addEventListener("click", function () {
        quantity++;
        section.querySelector(".productPurchaseQuantityDisplay").textContent = String(quantity);
        updateProduct().catch(err => console.error(err));
    });

    /**************
     Info content
     ***************/

    if (section.querySelector('.productInfo')) {
        // buttons change the type of content being shown on variant's info
        section.querySelectorAll('.productInfoItemTopButton')?.forEach(button => {
            button.addEventListener('click', function () {
                this.closest('.productInfoItem').querySelectorAll(`[data-type]`).forEach(el => {
                    el.dataset.type === this.dataset.type ? el.classList.add('active') : el.classList.remove('active');
                })
            })
        })
    }

    // selector label for color or fragrance
    if (section.querySelector('.productOptionsItemValuesName')) {
        section.querySelectorAll('.productOptionsItemValuesLabelInput').forEach(el => {
            const parent = el.closest('.productOptionsItemValues');
            el.addEventListener('mouseover', function () {
                if (window.innerWidth > 600) {
                    parent.querySelector('.productOptionsItemValuesName').textContent = this.value;
                    parent.querySelector('.productOptionsItemValuesName').style.opacity = "1";
                }
            })
            el.addEventListener('mouseout', function () {
                if (window.innerWidth > 600) {
                    parent.querySelector('.productOptionsItemValuesName').style.opacity = "0";
                }
            })
        })
    }

    /**************
     Notify Me
     ***************/

        // notify me button for not available variants
    const notifyMeDialog = section.querySelector('.productSoldOutDialog');
    section.querySelector('.productSoldOut').addEventListener('click', () => {
        document.querySelector('body').classList.add('noScroll');
        notifyMeDialog.showModal();
    })

    // closing listeners
    notifyMeDialog.addEventListener('click', function (e) {
        if (e.target === this) this.close()
    });
    notifyMeDialog.addEventListener('close', () => document.querySelector('body').classList.remove('noScroll'));
    section.querySelectorAll('.productSoldOutDialogClose').forEach(el => el.addEventListener('click', () => notifyMeDialog.close()));

    // submitting
    section.querySelector('.productSoldOutDialogForm').addEventListener('submit', function (e) {
        e.preventDefault();
        const variantId = this.querySelector('.productSoldOutDialogFormVariant').value || null;
        const email = this.querySelector('.productSoldOutDialogFormEmail').value || null;
        let phone = this.querySelector('.productSoldOutDialogFormPhone').value || null;
        if (variantId && email) {
            section.querySelector('.productSoldOutDialogFormButton').disabled = false;
            // format number if exists
            if (phone) {
                phone = formatPhoneNumberE164(phone)
            }
            // submit and offer confirmation message
            sendKlaviyoBackInStockRequest(email, variantId, phone).then(() => {
                section.querySelector('.productSoldOutDialogInner').classList.add('active');
            }).catch(err => console.error(err));
        }
    })

    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productPurchaseAtc").classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = currentSellingPlan();
        }

        // check for pre-order, add property for cart
        if (activeVariantMetafields.is_preorder) {
            formData.items[0].properties = {
                _preorder: true
            };
        }

        // check for liquid, then cart proof of gift box items - clear cart-> gift box sells by itself
        if (section.querySelector(".productGiftWarning")) {
            // fetch a fresh cart
            const currentCart = await getCart();
            if (currentCart.items.some(item => item.properties?._gift_box)) {
                await fetch(`${Shopify.routes.root}cart/clear.js`, {method: "POST"});
                // remove message
                section.querySelector(".productGiftWarning").remove();
            }
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productPurchaseAtc").classList.remove("loading");

        // open cart
        await openCart();
    }

    section.querySelector('.productPurchaseAtc').addEventListener("click", addToCart);
}());